import React from 'react';

export default class GenericNotFound extends React.Component {
    render() {
        return (
            <h1 style={{'textAlign': 'center'}}>NOT FOUND 404</h1>
        )
    }

};